import { render, staticRenderFns } from "./CertificationModal.vue?vue&type=template&id=4838ce1b&scoped=true"
import script from "./CertificationModal.vue?vue&type=script&lang=js"
export * from "./CertificationModal.vue?vue&type=script&lang=js"
import style0 from "./CertificationModal.vue?vue&type=style&index=0&id=4838ce1b&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4838ce1b",
  null
  
)

export default component.exports